<template>
  <div class="container-fluid">
    <br>
    <ul class="nav nav-tabs mt-4" role="tablist">
      <li class="nav-item">
        <a
          class="nav-link active"
          id="listings-tab"
          data-bs-toggle="tab"
          href="#listings"
          role="tab"
          aria-controls="listings"
          aria-selected="true"
        >
          Dispenser Guide Listings
        </a>
      </li>
      <li class="nav-item">
        <a
          class="nav-link"
          id="upload-tab"
          data-bs-toggle="tab"
          href="#upload"
          role="tab"
          aria-controls="upload"
          aria-selected="false"
        >
          Dispenser Guide Upload
        </a>
      </li>
    </ul>
    <div class="tab-content mt-4">
      <div
        class="tab-pane show active"
        id="listings"
        role="tabpanel"
        aria-labelledby="listings-tab"
      >
        <dispenser-guides></dispenser-guides>
      </div>
      <div
        class="tab-pane"
        id="upload"
        role="tabpanel"
        aria-labelledby="upload-tab"
      >
        <dispenser-guide-form></dispenser-guide-form>
      </div>
    </div>
  </div>
</template>

<script>
import DispenserGuides from "./DispenserGuides";
import DispenserGuideForm from "./DispenserGuideForm";

export default {
  components: {
    'dispenser-guides': DispenserGuides,
    'dispenser-guide-form': DispenserGuideForm
  }
}
</script>
